const initialState = {
  usuario: {
    id: "",
    nombre: "",
  },
};

export default initialState;
